const flightNumbers = [
    {value: "117", label: 117}
]

export default flightNumbers;